import { ErrorMessageContents } from '../../../helpers/hub'
import { BBMISIN } from './types'

export const saveBBMISINs = (bbmIsins: BBMISIN[]) =>
  ({ type: 'bbmisin.saveBBMISIN', payload: bbmIsins } as const)
type SaveBBMISINsAction = ReturnType<typeof saveBBMISINs>

export const saveBBMISINsSuccess = (unfoundIsins: string) =>
  ({ type: 'bbmisin.saveBBMISINSuccess', payload: unfoundIsins } as const)
export type SaveBBMISINsSuccessAction = ReturnType<typeof saveBBMISINsSuccess>

export const saveBBMISINsFailure = (error: ErrorMessageContents) =>
  ({ type: 'bbmisin.saveBBMISINFailure', payload: error, error: true } as const)
export type SaveBBMISINsFailureAction = ReturnType<typeof saveBBMISINsFailure>

export const clearError = () => ({ type: 'bbmisin.clearBBMISINError' } as const)
export type ClearErrorAction = ReturnType<typeof clearError>

export type BBMISINAction =
  | SaveBBMISINsAction
  | SaveBBMISINsSuccessAction
  | SaveBBMISINsFailureAction
  | ClearErrorAction
